/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaCancellationDetails } from "../../entities/yookassa/CancellationDetails";
import { z } from "zod/v4";

export const yookassaCancellationDetailsSchema = z.object({
    "party": z.optional(z.string()),
"reason": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaCancellationDetails>